<mat-card class="record-card" *ngIf="stockItem">
  <mat-card-content>
  <table class="table table-sm table-hover table-striped">
    <thead>
    <tr style="border:none">
      <th colspan="2" class="record-title">Stock Item</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>Label:</td>
      <td class="detail-label">{{ stockItem.stockItemAnnotationData?.label | ellipsis:30 }}</td>
    </tr>
    <tr>
      <td>Serial Number:</td>
      <td class="detail-label">{{ stockItem.externalIdentifier }}</td>
    </tr>
    <tr>
      <td>Stock Item Id:</td>
      <td class="detail-label">{{ stockItem.stockItemId }}</td>
    </tr>
    <tr>
      <td>Stock Item Set Id:</td>
      <td class="detail-label">{{ stockItem.stockItemSetId }}</td>
    </tr>
    <tr>
      <td>Status:</td>
      <td class="detail-label">{{ stockItem.status }}</td>
    </tr>
    <tr>
      <td>Created:</td>
      <td class="detail-label">{{ stockItem.created | date: "yyyy-MM-dd HH:mm:ss" }}</td>
    </tr>
    <tr>
      <td>Stock Item Data:</td>
      <td class="detail-label">
        <ae-json [json]="stockItem.stockItemAnnotationData"></ae-json>
      </td>
    </tr>
    <tr>
      <td>Stock Item Set Data:</td>
      <td class="detail-label">
        <ae-json [json]="stockItem.stockItemSetAnnotationData"></ae-json>
      </td>
    </tr>
    </tbody>
  </table>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="!stockItem">
  <mat-card-content>
    Missing
  </mat-card-content>
</mat-card>

